export const locale = {
    lang: 'es',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': 'Encuesta piloto:',
        'ENCUESTA_PILOTO_ENVIO': 'Envío de encuesta piloto',
        'ENCUESTA_LANZAMIENTO':'Confirmación de lanzamiento',
        'BTN_COPY':'Copiar clave ',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'Crear encuesta',
        'ENCUESTA_DEMO':'Encuesta piloto',
        'BOTON_CREAR_ENCUESTA':'Generar encuesta',
        'STEP': 'Paso completo',
        'SEE_TI': 'Ver requerimientos técnicos',
        'CLAVE': 'Clave de acceso:',
        'ACCESO': 'ACCESO',
        'NOFECHA':'No puede realizar esta acción porque aún no programa una fecha de lanzamiento',
        'LABEL01': 'Copie y pegue la clave de acceso dentro de la encuesta piloto',
        'LABEL02': 'Se ha confirmado el envío de la encuesta',
        'LABEL03':'Correo electrónico',
        'LABEL04': 'Envío de la encuesta piloto',
        'LABEL05': 'No se pudo realizar la acción',
        'LABEL06': 'La encuesta piloto se ha enviado correctamente',
        'LABEL07': 'Campo requerido',
        'LABEL08': 'Completar paso',
        'LABEL09': 'Se han agotado los usuarios demo de la encuesta',
        'CONFIRMAR_ENVIO': 'Confirmar envío de los correos',
        'DES_CONFIRMAR_ENVIO': 'Desconfirmar envío de los correos',
        'SI_CONFIRMAR_ENVIO': 'Sí',
        'NO_CONFIRMAR_ENVIO': 'No',
        'CHANGE-OPTIONS':'Cambiar las opciones de correo',
        'NO_ENVIO_CORREO':'No se enviará ningún correo',
        'SI_ENVIO_CORREO':'Los correos serán enviados',
        'EN_CASO':'Al seleccionar NO, toda la comunicación referente a la encuesta deberá ser por fuera de la plataforma. No se enivará ningún correo electrónico a los usuarios.',
        'CONFIRMAR_ENVIO_35': 'Confirme envío de la encuesta',
        'AUTOLOG_35': 'Enlace para inicio de sesión automático en la encuesta:',
        'TITULO':'En esta sección podrá realizar una prueba de visualización de la encuesta:',
        'LINK':'1. Acceda al siguiente enlace:',
        'LINKNORMA35':'1. Acceda al siguiente enlace para la encuesta de',
        'CLAVE_ENCUESTA':'2. Copie esta clave de prueba:',
        'INSTRUCCION3':'3. Pegue la clave en la celda de contraseña',
        'INSTRUCCION4':'4. Clic en iniciar sesión',
        'TEXTO_CONFIRMAR':'Confirmar que la comunicación con los usuarios (Invitación y recordatorios) se hará por correo electrónico',
        'TEXTO_CONFIRMAR2':'EN CASO DE QUE NO QUIERAS QUE LOS CORREOS SEAN ENVIADOS, simplemente omite dar clic y cierra el paso.',
        'TITULO_PILOTO':'En esta sección podrá enviar el correo de invitación de participación, hasta a cinco diferentes colaboradores, para realizar una prueba de recepción del correo y visualización de la encuesta, previo al lanzamiento real de la encuesta:',
        'INSTRUCCION_PILOTO':'1. Introduzca los correos electrónicos y seleccione el idioma en el que desee recibir la invitación',
        'INSTRUCCION_PILOTO2':'2. De clic en el botón "Envío de la encuesta piloto"',
        'SELLANG': 'Seleccione un idioma',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> Para confirmar que no se enviarán los correos electrónicos de invitación o recordatorio, ingrese el codigo en rojo en la caja de texto ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'Se modificó la configuración',

        'BTN_MODALES':{
          'CONFIRMAR':'Confirmar',
          'SALIR':'Salir',
        }
        },


        'URL35':{ // Sive unicamente para dispatch de la norma 35
          'MAS50':'más 50',
          'MENOS50':'menos 50',
          'CORTA': 'Aceeso general',
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1. Acceda al siguiente enlace:',
          'CLAVE_ENCUESTA':'2. Copie una de las claves generadas en la seccion de "usuarios demo"',
          'INSTRUCCION3':'3. Pegue la clave en la celda de contraseña',
          'INSTRUCCION4':'4. Clic en iniciar sesión',
          'USERSDEMO':'Usuarios demo',
          'USERS':'Usuario',
          'CLAVE':'Clave',
          'ESTATUS':'Estatus',
          'ESTATUS-USER-ASIGNA':'Asignado',
          'INST_UPD_URL_NAME':'Personalize el ShortUrl escribiendo hasta 6 caracteres de texto que sea familiar para sus usuarios',
          'BTN_UPD_GUARDA':'Guardar',
          'BTN_UPD_CAN':'Cancelar',
          'CUS_SHOI_URL':'Personalizar la url de la encuesta',
          'MODAL_ACTU_CUS_SHOI_URL':'Actualizando el nombre en la url',
          'ACTU_CUS_SHOI_URL_OK':'Se actualizó el nombre en la url correctamente',
          'ACTU_CUS_SHOI_URL_FALSE':'El nombre en la url ya existe',

        },


        'ALERT':{
            'HEADER':'Info',
            'MESSAGE_CON': '¿Desea confirmar el envío de los correos electrónicos a los usuarios?',
            'MESSAGE': '¿Desea confirmar el envío de los correos electrónicos a los usuarios?',
            'MESSAGE_DESCON': '¿Está seguro de no realizar la confirmación del envío de los correos electrónicos a los usuarios?',
            'BTN_CANCEL': 'No, cancelar',
            'BTN_CONFIRM': 'Ok, enviar',
            'BTN_NO_CONFIRM': 'No, enviar',
            'BTN_SI_CONFIRM': 'Sí, enviar',
            'BTN_NO_CANCEL': 'Cancelar',
            'BTN_OK': 'Ok',
            'ERROR_01':'Aún no has enviado ninguna invitación',
            'SINCOLABS': 'Aún no puede enviar la invitación de la encuesta, primero debe cargar la lista de colaboradores de la empresa',
            'SINLANG': 'Aún falta seleccionar el idioma para uno o más correos introducidos',
            'ERRMAIL': 'El correo introducido no cuenta con la sintaxis correcta, revíselo y vuelva a ingresarlo'
        }
      },
      'PULSE':{
          'LABEL01': 'Envie la encuesta a sus  colaboradores',
      }
    }
};
